"use strict";

Handlebars.registerHelper('permission', function(options) {
    var pass = true;
    if ('require' in options.hash) {
        var requiredPermission = options.hash['require'];
        if (requiredPermission == 'impersonate' && window.localStorage && window.localStorage.impersonate) return options.fn(this);
        pass = Core.client && Core.client.hasPermission(requiredPermission);
    }
    return pass ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('feature', function(options) {
    var pass = true;
    if ('name' in options.hash) {
        var requiredFeature = options.hash['name'];
        pass = Core.client && Core.client.hasFeature(requiredFeature)
        && ((Core.client.me.get('primaryGroupId') && Core.client.me.isSharingAllWithPrimaryGroup()) ? Core.client.groupHasFeature(Core.client.me.get('primaryGroupId'), requiredFeature) : Core.client.hasFeatureInAnyGroup(requiredFeature));
    }
    return pass ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('t', function (i18n_key) {
    var result = i18next.t(i18n_key);
    return new Handlebars.SafeString(result);
});

Handlebars.registerHelper('tr', function(context, options) {
    var opts = i18next.functions.extend(options.hash, context);
    if (options.fn) opts.defaultValue = options.fn(context);
    var result = i18next.t(opts.key, opts);
    return new Handlebars.SafeString(result);
});

Handlebars.registerHelper('tvariant', function(i18n_key) {
    var key = i18n_key;
    if (Core.client && Core.client.primaryGroup() && Core.client.primaryGroup().get('languageVariant')) {
        key += Core.client.primaryGroup().get('languageVariant');
    }
    var result = i18next.t(key);
    return new Handlebars.SafeString(result);
});

